import React from 'react'

import { reverse } from 'named-urls'

import { Box } from '@material-ui/core'

import ClientAddress from './components/ClientAddress'
import ClientData from './components/ClientData'
import ClientDisable from './components/ClientDisable'
import LatestContracts from './components/LatestContracts'

import { routes } from 'routes'
import { Permitted } from 'components/Permissions'
import { Container, ContentHeader } from 'components'
import { LogButton } from 'components/Logs'
import * as service from 'service'
import useFetch from 'hooks/useFetch'

const ClientsShow = ({ match }) => {
  const { clientId } = match.params
  const { response, isLoading } = useFetch(service.recurrence.customers.get, {
    clientId,
  })
  const [customer, setCustomer] = React.useState({})

  React.useEffect(() => {
    if (!response) {
      return
    }

    setCustomer(response.data.customer)
  }, [response])

  return (
    <Container>
      <ContentHeader title="Cliente" subtitle="Detalhes">
        <LogButton
          to={reverse(routes.clients.logs, {
            clientId,
          })}
        />
      </ContentHeader>
      <Box mb={4}>
        {response && (
          <ClientData
            data={customer}
            isLoading={isLoading}
            clientId={clientId}
            setCustomer={setCustomer}
            editable
          />
        )}
      </Box>

      <Box mb={4}>
        {response && (
          <ClientAddress
            address={customer.address}
            clientId={clientId}
            isLoading={isLoading}
            setCustomer={setCustomer}
            editable
          />
        )}
      </Box>

      <Box mb={4}>{response && <LatestContracts clientId={clientId} />}</Box>

      <Permitted tag="destroy_customer">
        <ClientDisable
          data={response && response.data.customer}
          clientId={clientId}
        />
      </Permitted>
    </Container>
  )
}

export default ClientsShow
